















































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default Vue.extend({
	name: 'Login',
	mixins: [validationMixin],
	validations: {
		email: {email, required},
		password: {required}
	},
	data: () => ({
		email: '',
		password: ''
	}),
	created() {
		console.log('isLoggedIn: ' + this.isLoggedIn)
	},
	methods: {
		loginClick: async function () {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				console.log(this.$v['email'].$error )
				console.log(this.$v['email'])
				this.$store.commit("CHANGE_LOADING", true)
				await this.$store.dispatch("login", {email: this.email, password: this.password})
				this.$store.commit("CHANGE_LOADING", false)
			}
		},
		getError: function (element: string) {
			if (this.$v[element].$error) return 'Invalid'
			return;
		}
	},
	computed: {
		...mapGetters([
			'isLoading', 'isLoggedIn'
		])
	},
	watch: {
		isLoggedIn: function (isLoggedIn) {
			if (isLoggedIn === true) this.$router.replace({name:'InstrumentosList'})
		}
	}
})
